(async () => {
	const {
		updateURLParams: n,
		historyPush: i,
		parseHTML: a
	} = await import(window.theme.modules.utils);
	var t = await import(window.theme.modules.baseComponent);
	customElements.define("product-form", class extends t.default {
		elements = {
			form: "form",
			addButton: "[data-add-button]",
			buyButton: "[data-buy-button]",
			content: "[data-content]",
			input: "[data-variant-id-input]",
			sellingPlanInput: 'input[name="selling_plan"]'
		};
		async render() {
			if (this._enableInput(), this.cartSection = document.querySelector("main-cart"), 
                this.isProductPage = "product" === this.getAttribute("page-type"), 
                this.listenTo("variantChange", (t, e) => {
					this._rerender(e), e.variant && this._rerenderVariantInput(e)
              
               var customJson = this.querySelector("[data-custom-product-json]");
                  if(customJson) {
                    var custom_jsonData = JSON.parse(customJson.innerHTML);
                    var variant_inventories = custom_jsonData.inventories[e.variant.id];
                        var preorderTextEl = this.querySelector('.preorderText');
                        var preorderDateEl = preorderTextEl.querySelector('.preorderDate');
                    var estimated_ship_datePropEl = preorderTextEl.querySelector('#estimated_ship_date');
                    
                    

                    
                    if(variant_inventories.preorderDate.length && variant_inventories.inventory_quantity <= 0 && variant_inventories.inventory_policy == 'continue' && variant_inventories.inventory_management == 'shopify') {
                      estimated_ship_datePropEl.value = variant_inventories.preorderDate;
                      preorderDateEl.innerHTML = variant_inventories.preorderDate;
                      preorderTextEl.classList.add('show');
                    } else {
                      estimated_ship_datePropEl.value = '';
                      preorderTextEl.classList.remove('show');
                    }
                  }
                  
				}), this.on("cartChange", (t, e) => {
					this._updateQtyStatus(e.variantId)
				}, !1), this.hasAttribute("cart-popup") && this.$form.addEventListener("submit", this._handleSubmit.bind(this)), this.$sellingPlanInput && this.hasAttribute("selling-plan-enable")) {
				this.currentSellingPlanId = this.querySelector('input[name="selling_plan"]').value;
				const {
					observeInputValueChange: t
				} = await import(window.theme.modules.sellingPlanUtil);
				t(this.$sellingPlanInput, this._handleSellingPlanChange.bind(this))
			}
		}
		_handleSellingPlanChange(t) {
			var e;
			t !== this.currentSellingPlanId && (this.currentSellingPlanId = t, {
				queryURL: e,
				currentURL: t
			} = n({
				selling_plan: this.currentSellingPlanId,
				variant: this.getAttribute("current-variant")
			}, this.sectionId), this.isProductPage && i(t), this._fetchPageWithVariant(e, t => {
				this.forwardEvent("sellingPlanChange", {
					html: t
				})
			}))
		}
		_enableInput() {
			this.$input.disabled = !1
		}
		_fetchPageWithVariant(t, e) {
			return fetch(t).then(t => t.text()).then(t => {
				t = a(t);
				e(t)
			})
		}
		_rerender(t) {
			const e = t.html.querySelector(`#${this.id} [data-content]`);
			this.$content.replaceChildren(...e.cloneNode(!0).childNodes), this._rerenderPaymentButton()
		}
		_rerenderVariantInput(t) {
			this.setAttribute("current-variant", `${t.variant.id}`);
			t = t.html.querySelector(this.elements.input).value;
			this.$input.value = t       
		}
		_rerenderPaymentButton() {
			window.Shopify?.PaymentButton?.init && window.Shopify.PaymentButton.init()
		}
		_handleSubmit(t) {
			t.preventDefault();

             var engraving_inputs = document.querySelectorAll(".engraving_row.show");          
          if(engraving_inputs.length){
            for (let index = 0; index < engraving_inputs.length; index++) {
              if(engraving_inputs[index].querySelector("input").value == ""){
                var error_text = document.querySelector(".engraving_error");
                if(error_text){
                  error_text.style.display = "block";
                  setTimeout(function(){
                     error_text.style.display = "none";
                  }, 3000)
                  return;
                }
              }
            }
          }  


          
            this.formData = new FormData(t.target), this._addToCartRequest()
		}
		_addToCartRequest() {
          console.log('_addToCartRequest');
			this._setLoading(!0), fetch(`${window.routes.cart_add_url}.js`, {
				method: "POST",
				headers: {
					Accept: "application/javascript"
				},
				body: this.formData
			}).then(t => t.json()).then(() => {
              console.log(this.getAttribute('data-cart_type'));
              if(this.getAttribute('data-cart_type') == 'ajax_without_drawer' ) {

                var buttontextEl = this.querySelector('.button-text');
                if(buttontextEl) {
                  buttontextEl.innerHTML = window.theme.i18n.addedToCart;

                  setTimeout(function () {
                     buttontextEl.innerHTML = window.theme.i18n.addToCart;
                  },2000);
                }
			this.trigger("updateCart"); 
            this._setLoading(!1);
                
              } else {
				this.trigger("updateCart", {
					callback: () => {
						this._setLoading(!1), this._updateQtyStatus(this.formData.get("id")), this.cartSection ? this.cartSection.update() : this.trigger("openPopup", {
							target: "CART"
						})
					}
				})
              }

			}).catch(t => {
				this._setLoading(!1), console.log(t)
			})
		}
		_updateQtyStatus(e) {
			var t = `${this.getAttribute("product-url")}?variant=${e}&section_id=${this.getAttribute("section-id")}`;
			this._fetchPageWithVariant(t, t => {
				this.trigger("qtyStatusUpdate", {
					html: t,
					variantId: e
				}), this._rerender({
					html: t
				})
			})
		}
		_setLoading(t) {
          var addButton = this.$form.querySelector("[data-add-button]");
          if(addButton) {
			t ? addButton.setAttribute("loading", "") : addButton.removeAttribute("loading")
        }
		}
	})
})();